import type { ReportPlaceholderReportPlaceholderPageProps } from '../types/pages'
import { PageShell } from '@/components/layout/PageShell'


/**
 * In-app placeholder for report routes not yet fully migrated.
 * Stays in React — does not redirect to Angular.
 */
export function ReportPlaceholderPage({ title }: ReportPlaceholderReportPlaceholderPageProps) {
  return (
    <PageShell title={title}>
      <div className="rounded-md border border-border bg-card px-6 py-8 shadow-sm">
        <p className="text-base text-foreground">
          This report is being migrated to the React application. Functionality
          will match the legacy report once complete.
        </p>
      </div>
    </PageShell>
  )
}
